import { merge } from 'lodash';

import { PartialQuery } from '@shared/api/types';
import { getTimeTrackingGroups } from '@shared/time-tracking-groups/endpoints/getTimeTrackingGroups';

export function getTimeTrackingGroupsForEvent(eventId: number) {
  return (query?: PartialQuery) => getTimeTrackingGroups(merge({ filter: { event_id: eventId } }, query));
}
